import axios from 'axios'
import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { resultSchema } from '../schemas'
import { Alert, Autocomplete, Button, TextField } from '@mui/material'

const UploadResult = () =>{
    const [members, setMembers] = useState([])
    const [membersCount, setMembersCount] = useState()
    const [resultCount, setResultCount] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const uri = useSelector(state=>state.uri)
    const [response, setResponse] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [options, setOptions] = useState([])
    const [name, setName] = useState('')

    useEffect(()=>{
        axios.get(
            `${uri}records`,            
        ).then(res=>{            
            setIsLoading(false)
            setOptions(res.data.options.sort((a, b)=>{
                let x = a.label.toLowerCase()
                let y = b.label.toLowerCase()
                if (x < y) { return -1 }
                if (x > y) { return 1 }
                return 0
            }))
            setMembers(res.data.members)
            setMembersCount(res.data.membersCount)
            setResultCount(res.data.results)
        }).catch(err=>{
            console.log(err.response)            
            setIsLoading(false)
        })
    }, [response])
    
    const {handleBlur, handleChange, handleSubmit, handleReset, errors, touched, values} = useFormik({
        initialValues: {            
            email: '',
            score: ''        
        },
        validationSchema: resultSchema,
        onSubmit: (values)=>{
            values.name = members.find(each=>(each.email == values.email)).name
            setResponse('')
            setIsSubmitting(true)
            axios.post(
                `${uri}result`,
                values
            ).then(res=>{
                handleReset()
                setIsSubmitting(false)
                setResponse(res.data.message)                
            }).catch(err=>{
                console.log(err.response)
                err.response && err.response.data.message ? setResponse(err.response.data.message) : setResponse('Ensure you are connected to the internet')
                setIsSubmitting(false)
            })
        }
    })
    const emailChange = (event, value)=>{
        if (value === null) {
            value = ''
            setName('')
        } else {
            values.email = value.label
            setName(value.name)
        }        
    }
    return (
        <div className='container'>
            <div className='py-5'>
                <div>
                    <img src={require('../assets/logo.png')} className='m-4' />
                    <span className='fs-3 mt-5'>- YRHOAU</span>
                </div>
                <p className='fs-5'>
                    <span className='fw-semibold'>Result Upload</span> - Assessment Test for all Intending Members
                </p>
                <div className='col-md-6 d-flex justify-content-between'>
                    <p>
                        <span className='text-yrh fs-4 fw-bold'>
                            {
                                isLoading
                                ?
                                <span className='spinner-border spinner-border-sm'></span>
                                :
                                membersCount
                            }
                        </span> Intending Members
                    </p>
                    <p>
                        <span className='text-yrh fs-4 fw-bold'>
                            {
                                isLoading
                                ?
                                <span className='spinner-border spinner-border-sm'></span>
                                :
                                resultCount
                            }
                        </span> Results Uploaded
                    </p>
                </div>
                <div className='col-md-6'>
                    {
                        response !== ''
                        ? 
                        <Alert severity={response.includes('successfully') ? 'success' : 'error'}>
                            {response}
                        </Alert>
                        :
                        ''
                    }                    
                    <Autocomplete                                                                            
                        className='font-poppins my-2'  
                        onChange={emailChange} 
                        onBlur={handleBlur}
                        options={options}
                        renderInput={(params)=> <TextField {...params} label="Email" />}
                    />
                    <p className='text-yrh fw-semibold'>
                        {
                            name !== '' &&
                            name
                        }
                    </p>
                    <div className='my-2'>
                        <input name='score' value={values.score} onChange={handleChange} onBlur={handleBlur} className={errors.score && touched.score ? 'form-control is-invalid' : 'form-control'} placeholder='Percentage Score' type='number' />
                    </div>
                    <Button disabled={isSubmitting} onClick={handleSubmit} className={isSubmitting ? 'border border-yrh text-yrh font-poppins fw-bold w-100 py-2' : 'bg-yrh text-white font-poppins fw-bold w-100 py-2'}>
                        {
                            isSubmitting
                            ?
                            'Submitting...'
                            :
                            'Submit'
                        }
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default UploadResult